<template>
    <div class="transaction">
  
      <Header :mainHeader="true"/>
  
      <section id="transaction-products" style="padding: 10px 0px !important">
        <div class="containers">
          <h5 class="fw-bold">User Management<button class="pull-right btn btn-primary" style="float:right;margin:10px;" @click="openModal">Add User</button></h5>

            <div  v-if="showAddModal">
                <div style="width: 50%;" class="modal-container">
                    <h5 class="p-20">Add new User</h5>
                    <hr/>

                    <div class="p-30">
                        <label for="">Username</label>
                        <input type="text" name="pin" v-model="username" class="form-control" style="background:#fff; border: 1px solid #000">
                        
                        <label for="">User Name</label>
                        <input type="text" name="name" v-model="name" class="form-control" style="background:#fff; border: 1px solid #000">
                        
                        <label for="">User Email</label>
                        <input type="email" name="email" v-model="email" class="form-control" style="background:#fff; border: 1px solid #000">
                        
                        <label for="">User Phone</label>
                        <input type="text" name="phone" v-model="phone" class="form-control" style="background:#fff; border: 1px solid #000">
                        <button class="btn-style full" @click="postUser" style="margin-top: 10px;">Add User</button>
                    </div>
                   
                </div>
            </div>

        <div class="table-container" v-if="!showAddModal">
            <table class="table table-hover" id="usersTable">
                <thead>
                    <tr>
                        <th>No</th>
                        <th>Name</th>
                        <th>Phone</th>
                        <th>Email</th>
                        <th>username</th>
                    </tr>
                </thead>
                <!--
                <tbody v-if="users.length > 0">
                    <tr v-for="(user,index) in users" v-bind:key="user.id">
                        <td>{{ index+1 }}</td>
                        <td>{{ user.name }}</td>
                        <td>{{ user.phone }}</td>
                        <td>{{ user.email }}</td>
                        <td>{{ user.username }}</td>
                    </tr>
                </tbody>
                <p v-else  style="color: red; padding: 20px; font-size: 21px;">No Users found</p>
                -->
                <LoaderItem v-if="loading" />
            </table>
        </div>
         

        </div>
      </section>
  
    </div>
  </template>
  
<script>

import Header from '../../components/Header';
import Swal from 'sweetalert2'
import 'datatables.net-vue3';
import 'datatables.net-bs5';
import "datatables.net-buttons-bs5";
import "datatables.net-responsive-bs5";
import $ from 'jquery';
//import 'jszip';
import 'datatables.net-buttons/js/buttons.html5.js';
import 'datatables.net-buttons/js/buttons.html5.js';
import 'datatables.net-buttons/js/buttons.colVis.js';
import 'datatables.net-buttons/js/buttons.print.js';
import { formatDate } from '@/utils/commons';
import LoaderItem from "../../components/LoaderItem.vue"

export default {
name: 'UserPage',
components: {
    Header,
    LoaderItem

},
data(){
    return{
        token: JSON.parse(localStorage.getItem('access_token')),
        users: [],
        processedData: [],
        showAddModal: false,
        name: "",
        username: "",
        phone: "",
        email: "",
        loading: false
    }
},
methods:{
    openModal() { this.showAddModal =  true; },
    closeModal() { this.showAddModal = false; },
    
    async getUsers () {
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
        };
        const res = await fetch(process.env.VUE_APP_URL+'/users', requestOptions)
        const data = await res.json()
        if(data.status == true){
            this.users = data.users
            this.processedData = this.preprocessData(this.users)
            this.initializeDataTable()
        }else{
            Swal.fire({
                icon: 'error',
                title: 'Users not found',
                text: data.message
            })
        }
    },

    preprocessData(rawData) {
      return rawData.map(item => {
        return {
          indexNo: "1",
          name: item.name,
          phone: item.phone,
          email: item.email,
          username: item.username
        };
      });
    },

    initializeDataTable() {
    try {
        this.dataTable = $(this.$el).find('#usersTable').DataTable({
        responsive: true,
        language: {
            paginate: {
            previous: '<i class="fa fa-chevron-left"></i>', // Custom icon for previous button
            next: '<i class="fa fa-chevron-right"></i>', // Custom icon for next button
            },
        }, 
        dom: '<"datatable-buttons"B><"datatable-search"f>tip',
        buttons: [
            {
            extend: 'colvis',
            text: 'Column Visibility',
            className: 'btn-grey',
            },
            {
            extend: 'pageLength',
            text: 'Page Length',
            className: 'btn-grey',
            },
            {
            extend: 'csv',
            text: 'Export CSV',
            className: 'btn-grey',
            exportOptions: {
                columns: ':visible',
            },
            },
            {
            extend: 'pdfHtml5',
            text: 'Export PDF',
            orientation: 'landscape',
            className: 'btn-grey',
            exportOptions: {
                columns: ':visible',
            },
            customize: this.customizePDF
            },
        ],
        data: this.processedData,
        columns: [
            { data: null },
            { data: 'name' },
            { data: 'phone' },
            { data: 'email' },
            { data: 'username' }
        ],
        columnDefs: [
            {
            targets: 0,
            searchable: false,
            orderable: false,
            render: (data, type, row, meta) => {
                return meta.row + 1;
            },
            },
        ],
        });
    } catch (error) {
        console.log({ error })
    }
    },

    customizePDF(doc) {
        //const logoBase64 = this.convertToBase64(logo)
        //console.log(logoBase64)
        doc.pageMargins = [40, 40, 40, 40]; // Set margins for the entire page
        doc.defaultStyle.columnGap = 0
        doc.content[1].fillColor = '#f2f2f2'

        doc.header = () => {
            return {
            columns: [
                {
                width: '*',
                columns: [
                    /* {
                        image: logoBase64,
                        width: 150, // Adjust the width as needed
                    },*/
                    {
                    text: 'Taxpoint',
                    alignment: 'left',
                    margin: [40, 15, 0, 40], // Adjust margins as needed
                    // color: '#FFA500', // Orange color
                    color: '#000',
                    bold: true,
                    fontSize: 14,

                    }
                ]
                },
                {
                width: '*',
                stack: [
                    {
                    text: 'Products List',
                    alignment: 'right',
                    margin: [0, 15, 50, 0],
                    fontSize: 12,
                    color: '#4448B3'
                    },
                    {  
                    alignment: 'right',
                    margin: [300, 0, 0, 0],
                    width: '*',
                    columns: [
                        {
                        width: 'auto',
                        text: 'Date:',
                        alignment: 'right',
                        margin: [0, 0, 10, 0],
                        bold: true,
                        },
                        {
                        width: 'auto',
                        text: `${formatDate(new Date(), "true")}`,
                        alignment: 'right',
                        margin: [0, 0, 50, 0],
                        fontSize: 9
                        }
                    ]
                    }
                ]
                }
            ],
            fillColor: '#000000'
            };
        },

            doc.footer = (currentPage, pageCount) => {
            return {
                columns: [
                { width: '*', text: 'www.pavicongroup.co.ke', alignment: 'left' },
                { width: '*', text: 'contact@pavicongroup.co.ke', alignment: 'center' },
                { width: '*', text: `Page ${currentPage} of ${pageCount}`, alignment: 'center' },
                { width: '*', text: `Printed on ${formatDate(new Date(), "true")}`, alignment: 'right' }
                ],
                margin: [40, 10, 40, 10], // Margin for the whole footer
                fillColor: 'black'
            };
            };

        doc.styles.title = {
            color: '#4448B3',
            fontSize: 13,
            margin: [80, 0, 0, 40],
        };
    },

    async postUser() {
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
            body: JSON.stringify({ 
              username: this.username,
              userNm: this.name,
              adrs: this.email,
              cntc: this.phone
          })
        };
        const res = await fetch(process.env.VUE_APP_URL+'/users', requestOptions)
        const data = await res.json()
        if(data.status == true){
            Swal.fire({
                icon: 'success',
                title: 'Users Created Successful',
                text: data.message
            })
            this.getUsers()
            this.showAddModal = "none"
            this.email = ""
            this.username = ""
            this.phone = ""
            this.name = ""
        }else{
            Swal.fire({
                icon: 'error',
                title: 'Users not found',
                text: data.message
            })
        }

    }
},
mounted(){
    this.getUsers()
}
}
</script>